<template>
    <div class="dept-container">
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <el-button type="primary" :icon="Plus" @click="onAddClick()" v-permission="['monitor:job:add']">
                        添加
                    </el-button>
                    <el-button :icon="DCaret" @click="handleSort" v-permission="['monitor:job:sort']">一键排序</el-button>
                </div>
            </template>
            <el-table :data="table_data" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="任务名称"></el-table-column>
                <el-table-column prop="task_type" label="任务类型" width="100">
                    <template #default="{ row }">
                        {{ row.task_type == 1 ? '默认' : '系统' }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="70">
                    <template #default="{ row }">
                        <el-switch
                            v-model="row.status"
                            :active-value="1"
                            :inactive-value="0"
                            @change="(val) => handleStatus(val, row)"
                        />
                    </template>
                </el-table-column>
                <el-table-column prop="list_order" label="排序" width="130">
                    <template #default="scope">
                        <el-input-number
                            style="width: 100px"
                            type="number"
                            v-model="scope.row.list_order"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                            size="small"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['monitor:job:edit']">
                            编辑
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            :icon="Delete"
                            @click="onRemoveClick(row)"
                            v-permission="['monitor:job:remove']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>

        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :formId="selectFormId"
            :periodTypes="period"
            :taskTtypeOptions="taskType"
            @updateForm="getTableData"
        ></forms-dialog>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { batchDisable, batchEnable, batchSort, delTask, getTaskList } from '@/api/job.js'
import { DCaret, Delete, Edit, Plus } from '@element-plus/icons'
import { getDataCodeOptions } from '@/utils/common'
// ElMessage

// 数据相关
const table_data = ref([{}])
const total = ref(0)
const page = ref(1)
const size = ref(10)
// 获取数据的方法
const getTableData = async () => {
    const result = await getTaskList({
        page: page.value,
        page_size: size.value
    })
    table_data.value = result.lists
    total.value = result.total
}
getTableData()

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectFormId = ref('') // 点中的模块id
// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) selectFormId.value = ''
})

const taskType = ref([])
const taskTypeObj = ref({})
const period = ref([])
const periodObj = ref({})
const getTaskOptionsFun = async () => {
    const task = await getDataCodeOptions('scheduled_task_task_type')
    taskType.value = task.list
    taskTypeObj.value = task.jsonData
    const periodOption = await getDataCodeOptions('scheduled_task_period')
    period.value = periodOption.list
    periodObj.value = periodOption.jsonData
}
// 查看
// const onShowClick = (row) => {
//     selectFormId.value = row.id
//     isForm.value = false
//     formDialogVisible.value = true
// }
// 编辑
const onEditClick = (row) => {
    selectFormId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectFormId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delTask(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

// 修改岗位状态
const handleStatus = (val, row) => {
    if (!row.id) return
    const msg = val ? '启用' : '停用'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.name}"任务吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            if (val) {
                await batchEnable([row.id])
            } else {
                await batchDisable([row.id])
            }
            ElMessage({
                type: 'success',
                message: msg + '成功'
            })
        })
        .catch(() => {
            row.status = val ? 0 : 1
        })
}

const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getTableData()
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
    getTaskOptionsFun()
})
</script>

<style lang="scss" scoped></style>
